




















































































import Vue from "vue";
import { mixins } from "vue-class-component";
import moment from "moment/moment";
import { Component, Prop } from "vue-property-decorator";
import MyMixin from "@/mixins/datemixin";
import MobileMixin from "@/mixins/mobileMixin";
import { Site } from "@/shared/Site";
import RapportMixin from "@/mixins/rapportMixin";
import NumberTmpl from "@/ui-component/number.vue";

@Component({
  components: { NumberTmpl },
})
export default class ExpandableTotal extends mixins(MyMixin, MobileMixin) {
  @Prop() public data!: any;
  @Prop({ default: false }) public isRepart!: boolean;
}
